export function initAdCampaignTotalCount(): void {
  const $count = $('#arf-camp-total-count');
  if (!$count.length) return;

  const $source = $('#render-async-stats [data-total-count]').first();
  if (!$source.length) return;

  $count.text($source.data('total-count'));
}

export function initAdsTabCounts(): void {
  const $source = $('#ads-tab-stats');
  if (!$source.length) return;

  const fill = (key: string, stat: string) => {
    const value = $source.data(key);
    if (value === undefined || value === null) return;
    $(`.arf-tab-badge[data-ads-stat="${stat}"]`).text(String(value)).removeClass('d-none');
  };

  fill('campaigns', 'campaigns');
  fill('adsets', 'adsets');
  fill('ads', 'ads');
}

export function applyActiveFilteredCount(): void {
  const $source = $('#render-async-stats [data-total-count]').first();
  if (!$source.length) return;

  const total = $source.data('total-count');
  if (total === undefined || total === null) return;

  const $badge = $('.arf-tabs .arf-tab.active .arf-tab-badge[data-ads-stat]');
  if (!$badge.length) return;

  $badge.text(String(total)).removeClass('d-none');
}

// The tab badges are counted server-side under the current filters, so they are
// fetched rather than inlined: changing the selection re-counts them in place.
let statsRequest = 0;
let statsTimer: number | undefined;

export function loadAdsTabStats(): void {
  const $holder = $('#ads-tab-stats-async');
  const url = $holder.attr('data-url');
  if (!url) return;

  const request = ++statsRequest;
  $.get(url, (html: string) => {
    if (request !== statsRequest) return; // a later selection already asked

    $holder.html(html);
    initAdsTabCounts();
    applyActiveFilteredCount();
  });
}

// Picking several campaigns in a row would otherwise fire a live Graph API
// count per click.
export function scheduleAdsTabStats(): void {
  window.clearTimeout(statsTimer);
  statsTimer = window.setTimeout(loadAdsTabStats, 250);
}
